<template>
  <div id="summaryContainer" :class="$style.summaryContainer">
    <div :class="$style.progressBar">
      <span
        :class="$style.progression"
        :style="`height: ${barProgression}px`"
      />
    </div>
    <ul :class="$style.summaryList">
      <li
        v-for="(title, titleIndex) in titlesArray"
        :id="`summaryTitle${titleIndex}`"
        :key="titleIndex"
        :class="{
          [$style.activeTitle]: title.anchor === titlesProgression[titleIndex],
        }"
      >
        <a :href="`#${title.anchor}`">
          {{ title.text }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Summary',

  props: {
    titlesArray: {
      type: Array,
      default: () => [],
    },
    titlesProgression: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    barProgression() {
      if (this.titlesProgression.length === 0) return 0
      const progressionElem = document.getElementById(
        `summaryTitle${this.titlesProgression.length - 1}`
      )
      if (this.titlesProgression.length === this.titlesArray.length)
        return progressionElem.offsetTop + progressionElem.clientHeight

      return progressionElem.offsetTop + progressionElem.clientHeight / 2
    },
  },

  methods: {
    titleId(title) {
      const formatedTitle = title
        .split(' ')
        .map((e) => e.split(''))
        .filter((e) => e.length > 1)
        .map((e, i, a) => e.join(''))
        .join('-')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036F]/g, '')
      return formatedTitle
    },
  },
}
</script>

<style lang="scss" module>
.summaryContainer {
  position: relative;

  width: 100%;
  height: 100%;
}

.progressBar {
  position: absolute;
  top: 0;
  left: 0;

  width: 8px;
  height: 100%;
  border-top-right-radius: 8px;
  border-bottom-left-radius: 8px;
  overflow: hidden;

  background-color: $gray-100;
}

.progression {
  display: block;
  width: 100%;

  background-color: $bluko-500;

  transition: height 0.3s;
}

.summaryList {
  padding-left: 24px;
  li a {
    display: block;
    padding: 12px 0;

    color: $gray-700;
    text-decoration: none;
    @include typo-body;

    &:hover {
      text-decoration: underline;
    }
  }
}

li.activeTitle a {
  color: $bluko-500;
}
</style>
